import { useState, useEffect, useCallback } from "react";

// Captures the beforeinstallprompt event so the app can trigger an install
// from a user gesture. iOS Safari doesn't fire it — caller should detect iOS
// and show an "Add to Home Screen" hint instead.
export default function usePwaInstall() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    setInstalled(standalone);

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferred) return null;
    deferred.prompt();
    const choice = await deferred.userChoice;
    setDeferred(null);
    return choice?.outcome ?? null;
  }, [deferred]);

  const isIos = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;

  return {
    canInstall: Boolean(deferred),
    isInstalled: installed,
    isIos,
    promptInstall,
  };
}
